import { useEffect, useState } from "react";
import { Association } from "src/interfaces/Common";
import { PagesID } from "@utils/utilsConfigurations";
import { ServicesURL } from "@utils/utilsApi";
import { useParams } from "react-router-dom";

export const useAddEditGoodReceipt = (dataDetail?: any) => {
  const { id, idProject } = useParams();

  interface Customer {
    id: number;
    business_name: string;
  }

  const [openAssociations, setOpenAssociations] = useState<
    boolean | Association
  >(false);
  const [customerAssociation, setCustomerAssociation] = useState<any>([]);

  const formatCustomer = (customers: any) => {
    const formattedCustomers = customers.map((customer: Customer) => ({
      id: customer.id,
      label: customer.business_name,
    }));
    setCustomerAssociation(formattedCustomers);
  };

  useEffect(() => {
    if (dataDetail?.customers) {
      formatCustomer(dataDetail.customers);
    }
  }, [dataDetail]);

  const resetGoodReceiptAssociations = () => {
    if (dataDetail) {
      dataDetail.customers
        ? formatCustomer(dataDetail.customers)
        : setCustomerAssociation([]);
    }
  };

  const setOpenAssociation = (accessorKey: string, value: boolean) => {
    switch (accessorKey) {
      case "customer":
        setOpenAssociations(
          value
            ? {
                accessorKey: "customer",
                mediaType: "customers",
                type: "table",
                titleKey: "customers-association",
                pageId: PagesID["customers"],
                service: `${ServicesURL.getCustomers}?corporateId=${id}&budgetProjectId=${idProject}`,
                multiChoice: false,
              }
            : value,
        );
        break;
    }
  };

  const getValues = (accessorKey: string) => {
    switch (accessorKey) {
      case "customer":
        return customerAssociation;
    }
  };

  const handleDelete = (accessorKey: string, e: any) => {
    switch (accessorKey) {
      case "customer":
        setCustomerAssociation(
          customerAssociation.filter((element: any) => element.id !== e.id),
        );
        break;
    }
  };

  const handleAssociation = (accessorKey: string, value: any) => {
    switch (accessorKey) {
      case "customer":
        const objToCustomerAssociation: any = Object.keys(value).map(
          (key: string) => {
            if (key.includes("||")) {
              return {
                id: key.split("||")[0],
                label: key.split("||")[1],
              };
            } else {
              return objToCustomerAssociation.find(
                (elem: any) => elem.id === +key,
              );
            }
          },
        );
        setCustomerAssociation(objToCustomerAssociation);
        break;
    }
  };

  return {
    handleAssociation,
    setOpenAssociation,
    handleDelete,
    getValues,
    resetGoodReceiptAssociations,
    setCustomerAssociation,
    customerAssociation,
    openAssociations,
  };
};
